import axios from 'axios';
import config from '../config/config.json';
import { FullGuild } from '../models/guild';

// Get headers with session token
export const getHeaders = () => {
  const sessionToken = localStorage.getItem('session_token');
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (sessionToken) {
    headers['session-token'] = sessionToken;
  }

  return headers;
};

/**
 * Fetch all guilds/teams with full data including tours and participants
 */
export async function getAllFullGuilds(): Promise<FullGuild[]> {
  const response = await axios.get(`${config.backend_base_url}api/public/teams/full`);
  return response.data;
}
